import React, { useState, useEffect } from 'react'
import { Button, Space, Modal, Tag, Popover } from 'antd'
import Update from './Update'
import PageLoader from '../../components/Layouts/PageLoader'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom/cjs/react-router-dom'
import {
  successNotification,
  carsUrl,
  postRequest,
  deleteRequest,
  errorNotification
} from '../../config'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import ReactMarkdown from 'react-markdown'
import { generalPost, telegramPost, twitterPost } from './socialPost'

const DetailSection = props => {
  const { car, payload } = props

  // eslint-disable-next-line
  const [loading, setLoading] = useState(false)
  const [refreshLoading, setRefreshLoading] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [showRefreshModal, setShowRefreshModal] = useState(false)
  const [modalKey, setModalKey] = useState(1)

  useEffect(() => {
    if (showModal) {
      setModalKey(modalKey + 1)
    }
    // eslint-disable-next-line
  }, [showModal])

  // eslint-disable-next-line
  let nf = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  })

  const handleDeleteCar = async () => {
    const response = await deleteRequest(
      `${carsUrl}/${car.id}`,
      'car',
      setLoading
    )
    if (response.success) {
      successNotification('Car deleted successfully')
      // props.history.push('/cars')
      props.history.push('/')
    } else {
      errorNotification('Cars with existing orders cannot be deleted.')
    }
  }

  const handleRefreshCarfax = async () => {
    const response = await postRequest(
      `${carsUrl}/${car.id}/refresh-carfax/`,
      {},
      'carfax',
      setRefreshLoading
    )
    if (response.success) {
      successNotification('Carfax refreshed successfully')
      setShowRefreshModal(false)
      props.handleSuccess()
    } else {
      errorNotification(
        response.error.response?.data?.non_field_errors[0] ||
          'Error refreshing carfax'
      )
    }
  }

  return (
    <PageLoader className="container" loading={loading}>
      <div
        className="row"
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between'
        }}
      >
        <div className="col-md-5 mb-2rem">
          <div>
            <b>Car</b>
          </div>{' '}
          {String(
            `${car.year} ${car.make?.name} ${car.model?.name} ${car.trim}`
          ).toUpperCase()}
          <b>
            {car.fuelType &&
              `${
                [
                  'PETROL-HYBRID',
                  'DIESEL-HYBRID',
                  'PETROL-PLUG-IN-HYBRID',
                  'DIESEL-PLUG-IN-HYBRID'
                ].includes(car.fuelType.name)
                  ? ' Hybrid'
                  : ''
              }`}
          </b>
        </div>

        <div className="col-md-5 mb-2rem">
          <div>
            <b>Chassis Number</b>
          </div>
          {car.chassisNo}
          <div>
            <b>MSRP:</b> {car.msrp ? '$ ' + car.msrp : 'N/A'}
          </div>
          <div>
            <b>Duty:</b>{' '}
            {car.totalEstimatedDuty
              ? car.profitCurrency?.symbol +
                ' ' +
                nf.format(car.totalEstimatedDuty.total)
              : 'N/A'}
            {car.useManualCustomsDuty && (
              <div style={{ fontSize: '12px', color: '#888' }}>
                (Manual: {car.customsDutyCurrency?.symbol}{' '}
                {nf.format(car.customsDutyAmount)} @ {car.customsDutyUsdRate})
              </div>
            )}
          </div>
        </div>

        <div className="col-md-5 mb-2rem">
          <div>
            <b>Country of Origin</b>
          </div>
          {car.origin && car.condition
            ? car.origin.country + ' (' + car.condition.name + ')'
            : 'N/A'}
        </div>

        <div className="col-md-5 mb-2rem">
          <div>
            <b>Specs</b>
          </div>
          {car.bodyType ? car.bodyType.name : 'N/A'} |{' '}
          {car.fuelType ? car.fuelType.name : 'N/A'} |{' '}
          {car.transmission ? car.transmission.name : 'N/A'} |{' '}
          {car.driveTrain ? car.driveTrain.name : 'N/A'}
        </div>

        <div className="col-md-5 mb-2rem">
          <div>
            <b>Engine</b>
          </div>
          {car.engineSize}L | {car.engineCylinders}Cylinders |{' '}
          {car.engineHorsepower}HP | {car.engineDescription}
        </div>

        <div className="col-md-5 mb-2rem">
          <div>
            <b>Fuel Economy</b>
          </div>
          {car.fuelEconomyCity} CTY | {car.fuelEconomyHighway} HWY |{' '}
          {car.fuelEconomyCombined} COMB
        </div>

        <div className="col-md-5 mb-2rem">
          <div>
            <b>Color</b>
          </div>
          Ext: {car.exteriorColor} | Int: {car.interiorColor}
        </div>

        <div className="col-md-5 mb-2rem">
          <div>
            <b>Inside</b>
          </div>
          {car.noOfDoors} Doors | {car.passengers} Seats
        </div>

        <div className="col-md-5 mb-2rem">
          <div>
            <b>Mileage</b>
          </div>
          {nf.format(car.mileage)} {car.mileageUnit}
        </div>

        <div className="col-md-5 mb-2rem">
          <div>
            <b>Source Price</b>
          </div>
          {car.sourceCurrency ? car.sourceCurrency.symbol : 'N/A'}{' '}
          {nf.format(car.sourcePrice)}
          {Number(car.additionalCharge) > 0 && car.additionalChargeCurrency && (
            <span style={{ marginLeft: '5px' }}>
              (+{car.additionalChargeCurrency.symbol}{' '}
              {nf.format(car.additionalCharge)})
            </span>
          )}
          {car.priceCheckNote ? (
            <>
              <br />
              <div style={{ marginLeft: '5px' }}>
                <Tag color="orange">
                  Price Check:
                  <Popover
                    title="Price Check Note"
                    content={
                      <div
                        style={{
                          maxHeight: '300px',
                          overflowY: 'auto',
                          maxWidth: '400px'
                        }}
                      >
                        <ReactMarkdown>{car.priceCheckNote}</ReactMarkdown>
                      </div>
                    }
                    trigger="hover"
                  >
                    {car.priceCheckNote.slice(0, 25)}...
                  </Popover>
                </Tag>
              </div>
            </>
          ) : (
            ''
          )}
        </div>

        <div className="col-md-5 mb-2rem">
          <div>
            <b>Profit</b>
          </div>
          {car.profitCurrency
            ? `${car.profitCurrency.symbol} ${nf.format(car.profit)}`
            : 'N/A'}{' '}
          ({car.profitPercentage}%
          {car.serviceChargeUsd &&
            ` | Service: $${nf.format(car.serviceChargeUsd)}`}
          )
        </div>

        <div className="col-md-5 mb-2rem">
          <div>
            <b>Discount</b>
          </div>
          {car.discountCurrency
            ? `${car.discountCurrency.symbol} ${nf.format(car.discount)}`
            : 'N/A'}
        </div>

        <div className="col-md-5 mb-2rem">
          <div>
            <b>Selling Price</b>
          </div>
          {car.price > 0 ? (
            <span style={{ textWrap: 'wrap' }}>
              US$ {nf.format(car.priceUsd)} (GH₵ {nf.format(car.price)})
            </span>
          ) : (
            'N/A'
          )}
        </div>

        {/* What the public site actually shows: selling price + duty +
            clearing, as one GH₵ figure. Duty is no longer broken out to
            customers, so this is the only number they see. */}
        <div className="col-md-5 mb-2rem">
          <div>
            <b>Total (All-in, shown on site)</b>
          </div>
          {car.landedPriceGhs ? (
            <span style={{ textWrap: 'wrap' }}>
              GH₵ {nf.format(car.landedPriceGhs)}
              <div style={{ fontSize: '12px', color: '#888' }}>
                (selling price + duty & clearing)
              </div>
            </span>
          ) : (
            <span>
              N/A
              <div style={{ fontSize: '12px', color: '#888' }}>
                (duty could not be computed — check body type, origin, fuel
                type and source currency)
              </div>
            </span>
          )}
        </div>

        <div className="col-md-5 mb-2rem">
          <div>
            <b>Source URL</b>
          </div>
          {car.sourceUrl ? (
            <div className="">
              <a href={car.sourceUrl} target="blank">
                Click Here
              </a>
              <CopyToClipboard text={car.sourceUrl} className="ml-2">
                <Button type="default" onClick={() => {}}>
                  Copy
                </Button>
              </CopyToClipboard>
            </div>
          ) : (
            'N/A'
          )}
        </div>

        <div className="col-md-5 mb-2rem">
          <div>
            <b>Car Link</b>
          </div>
          {
            <a
              href={`https://wabenzyautos.com/cars/${car.slug}`}
              target="blank"
            >
              Click Here
            </a>
          }{' '}
          or
          <CopyToClipboard
            text={`https://wabenzyautos.com/cars/${car.slug}`}
            className="ml-2"
          >
            <Button type="default" onClick={() => {}}>
              Copy
            </Button>
          </CopyToClipboard>
        </div>

        <div className="col-md-5 mb-2rem">
          <div>
            <b>CarFax Report</b>
          </div>
          <div className="mb-1rem">
            Link:{' '}
            {car.carfaxUrl ? (
              <div className="">
                <a href={car.carfaxUrl} target="blank">
                  Click Here
                </a>
                <CopyToClipboard text={car.carfaxUrl} className="ml-2">
                  <Button type="default" onClick={() => {}}>
                    Copy
                  </Button>
                </CopyToClipboard>
              </div>
            ) : (
              'N/A'
            )}
          </div>

          <div className="mb-1rem">
            PDF:{' '}
            {car.carfaxPdfUrl ? (
              <div className="">
                <a href={car.carfaxPdfUrl} target="blank">
                  Click Here
                </a>

                <CopyToClipboard text={car.carfaxPdfUrl} className="ml-2">
                  <Button type="default" onClick={() => {}}>
                    Copy
                  </Button>
                </CopyToClipboard>
              </div>
            ) : (
              'N/A'
            )}
          </div>

          {car.carfaxUrl && (
            <div>
              <Button
                type="primary"
                onClick={() => {
                  setShowRefreshModal(true)
                }}
                loading={refreshLoading}
              >
                Refresh Carfax
              </Button>
            </div>
          )}
        </div>

        <div className="col-md-5 mb-2rem">
          <div>
            <b>Social Media Post</b>
          </div>
          {car ? (
            <div>
              <div className="mb-1rem">
                Posted on social media:{' '}
                <Tag color={car.postedOnSocialMedia ? 'green' : 'red'}>
                  {car.postedOnSocialMedia ? 'YES' : 'NO'}
                </Tag>
              </div>
              {/* <div className="mb-1rem">
                Posted on social media date:{' '}
                {car.postedOnSocialMediaDate}
              </div> */}

              <div className="mb-1rem">
                General Post:{' '}
                <CopyToClipboard
                  text={generalPost(car)}
                  title={generalPost(car)}
                  className="ml-2"
                >
                  <Button type="default" onClick={() => {}}>
                    Copy
                  </Button>
                </CopyToClipboard>
              </div>
              <div className="mb-1rem">
                Twitter:{' '}
                <CopyToClipboard
                  text={twitterPost(car)}
                  title={twitterPost(car)}
                  className="ml-2"
                >
                  <Button type="default" onClick={() => {}}>
                    Copy
                  </Button>
                </CopyToClipboard>
              </div>
              <div>
                Telegram:{' '}
                <CopyToClipboard
                  text={telegramPost(car)}
                  title={telegramPost(car)}
                  className="ml-2"
                >
                  <Button type="default" onClick={() => {}}>
                    Copy
                  </Button>
                </CopyToClipboard>
              </div>
            </div>
          ) : (
            'N/A'
          )}
        </div>

        {/* <div className="col-md-5 mb-2rem">
          <div>
            <b>Customs Duty Amount</b>
          </div>
          {car.customsDutyCurrency ? car.customsDutyCurrency.symbol : 'N/A'}{' '}
          {car.customsDutyAmount}
        </div>

        <div className="col-md-5 mb-2rem">
          <div>
            <b>Port Charges Amount</b>
          </div>
          {car.portChargesCurrency ? car.portChargesCurrency.symbol : 'N/A'}{' '}
          {car.portChargesAmount}
        </div> */}

        <div className="col-md-5 mb-2rem">
          <div>
            <b>Status</b>
          </div>
          {car.status && car.status.name.toUpperCase()}
        </div>

        {/* <div className="col-md-5 mb-2rem">
          <div>
            <b>Created On</b>
          </div>
          {new Date(car.createdAt).toDateString()}
        </div>

        <div className="col-md-5 mb-2rem">
          <div>
            <b>Updated On</b>
          </div>
          {new Date(car.updatedAt).toDateString()}
        </div> */}

        <div className="col-md-12">
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              marginBottom: '20px'
            }}
          >
            <Space>
              <Button
                type="primary"
                onClick={() => {
                  setShowModal(true)
                }}
                loading={loading}
              >
                Update Car
              </Button>
              <Button
                type="danger"
                onClick={() => {
                  setShowDeleteModal(true)
                }}
                loading={loading}
              >
                Delete Car
              </Button>
            </Space>
          </div>
        </div>

        <Modal
          title="Update Car Details"
          centered
          open={showModal}
          onOk={() => setShowModal(false)}
          onCancel={() => setShowModal(false)}
          footer={null}
          width={1000}
        >
          <Update
            key={modalKey}
            car={payload}
            handleCancel={() => {
              setShowModal(false)
              props.handleSuccess()
            }}
          />
        </Modal>

        <Modal
          title="Do You Really Want to Delete This Car?"
          centered
          open={showDeleteModal}
          onOk={() => setShowDeleteModal(false)}
          onCancel={() => setShowDeleteModal(false)}
          footer={null}
        >
          <div
            className="p-3"
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center'
            }}
          >
            <span className="text-danger mb-3">
              Deleting this car will cause issues with existing data from this
              company such as but not limited to Cars, etc.
            </span>
            <Button
              type="danger"
              onClick={() => {
                handleDeleteCar()
              }}
              loading={loading}
            >
              Delete Car
            </Button>
          </div>
        </Modal>

        <Modal
          title="Refresh Carfax Report"
          centered
          open={showRefreshModal}
          onOk={() => setShowRefreshModal(false)}
          onCancel={() => setShowRefreshModal(false)}
          footer={null}
        >
          <div
            className="p-3"
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center'
            }}
          >
            <span className="mb-3">
              Are you sure you want to refresh the Carfax report for this car?
              This process may take a few moments.
            </span>
            <Button
              type="primary"
              onClick={() => {
                handleRefreshCarfax()
              }}
              loading={refreshLoading}
            >
              Confirm Refresh
            </Button>
          </div>
        </Modal>
      </div>
    </PageLoader>
  )
}

DetailSection.propTypes = {
  car: PropTypes.object,
  payload: PropTypes.object,
  handleSuccess: PropTypes.func
}

export default withRouter(DetailSection)
